import NetInfo from '@react-native-community/netinfo';

export const monitorNetworkStatus = (callback) => {
	const unsubscribe = NetInfo.addEventListener((state) => {
		callback(state.isConnected);
	});
	return unsubscribe;
};
